'use client'
import Image from 'next/image'
import { Icon } from 'trimble-terra'
import { getTeaserImageUrlByEntry } from "@/lib/formatImages";

const RelatedPosts = ({ relatedPosts, locale = 'en-US', baseUrl, postType = "article", config }: { relatedPosts: any[], locale: string, baseUrl: string, postType: string, config: any }) => {

  const renderArticleSummary = (post: any) => {
    const articleSummary = post?.templateBlogSummaryCollection?.items?.[0]?.summaryText || post?.articleSummary || post?.articleSeo?.teaserDescription;
    return `${articleSummary?.split("").splice(0, 100).join("")}...`
  }

  const transformedSlug = (slug: string) => { 
    if(baseUrl) {
      return `${baseUrl}/${locale}/${postType}/${slug}`
    } else if (typeof window !== 'undefined') {
      return `${window?.location?.origin}/${locale}/${postType}/${slug}`
    }
    return `/${postType}/${slug}`
  }

  const relatedPostsTitle = postType === 'article' ? config?.commonTextLabels?.labelForRelatedArticlesSection : config?.commonTextLabels?.labelForRelatedCaseStudiesSection

  let label = config?.commonTextLabels?.labelForCardCta || "Read More"; // defaults to Article's CTA
  
  // Get the proper eyebrow label based on post type
  const getEyebrowLabel = (type: string) => {
    if (type === 'case-study') return config?.commonTextLabels?.labelForCaseStudy || 'case study';
    if (type === 'article') return config?.commonTextLabels?.labelForArticle || 'article';
    return type;
  };

  return (
    <>
      <div className="bg-mxpGray2 py-12 md:py-18 lg:py-24 w-full flex">
        <div className="max-w-7xl article-content-block w-full mx-auto">
          <h2 className="font-light mb-10 lg:mb-20 similar-posts-title">{relatedPostsTitle || "Similar Posts"}</h2>
          <div className="flex flex-col md:flex-row gap-9">
            {relatedPosts?.map((post: any, i: number) => {
              return (
                <div className="article-related-case-study w-full md:w-1/2 lg:w-1/3 rounded-lg bg-white flex flex-col" key={i}>
                  <Image src={getTeaserImageUrlByEntry(post, config, 413, 200)} width={413} height={200} 
                    alt={`${post.title}`} className={'article-summary-image'} 
                    style={{ maxHeight: `200px`, objectFit: "cover", borderRadius: '8px 8px 0 0', width: "100%" }} 
                  />
                  <div className="article-related-case-study-wrapper p-8 flex flex-col grow">
                    <span className="text-lg text-mxpGray-500 uppercase font-bold tracking-wider mb-2 uppercase">{getEyebrowLabel(postType)}</span>
                    <h3 className="text-lg font-bold mb-4">{post?.title}</h3>
                    <div className="font-normal grow">
                      {renderArticleSummary(post)}
                    </div>
                    <a href={transformedSlug(post.slug)} 
                      className="related-article-link flex items-center mt-6 text-mxpTrimbleBlue font-medium tracking-wider hover:text-black"
                    >
                      {label}
                      <Icon label="View Post" type={"t2u-chevron-right"} size={20} className="ml-2" />
                    </a>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default RelatedPosts